import { render } from "./SalesLeadDetail.vue?vue&type=template&id=3d96ec86&scoped=true&ts=true"
import script from "./SalesLeadDetail.vue?vue&type=script&lang=ts"
export * from "./SalesLeadDetail.vue?vue&type=script&lang=ts"

import "./SalesLeadDetail.vue?vue&type=style&index=0&id=3d96ec86&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d96ec86"]])

export default __exports__